import type { IconSvgProps } from '../Icon.types';

export const EditPenSimple = ({ fill, width, height, className }: IconSvgProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 13"
      
    >
      <path
        d="M12.2075 3.58547L9.41438 0.792974C9.32152 0.700091 9.21127 0.626411 9.08993 0.576142C8.96859 0.525873 8.83853 0.5 8.70719 0.5C8.57585 0.5 8.4458 0.525873 8.32446 0.576142C8.20312 0.626411 8.09287 0.700091 8 0.792974L0.29313 8.49985C0.199867 8.59237 0.125926 8.70251 0.0756045 8.82386C0.025283 8.94521 -0.000414649 9.07535 5.05934e-06 9.20672V11.9998C5.05934e-06 12.2651 0.105362 12.5194 0.292898 12.707C0.480435 12.8945 0.734789 12.9998 1.00001 12.9998H11.5C11.6326 12.9998 11.7598 12.9472 11.8536 12.8534C11.9473 12.7596 12 12.6325 12 12.4998C12 12.3672 11.9473 12.2401 11.8536 12.1463C11.7598 12.0525 11.6326 11.9998 11.5 11.9998H5.20751L12.2075 4.99985C12.3004 4.90699 12.3741 4.79674 12.4243 4.6754C12.4746 4.55406 12.5005 4.424 12.5005 4.29266C12.5005 4.16132 12.4746 4.03127 12.4243 3.90992C12.3741 3.78858 12.3004 3.67834 12.2075 3.58547ZM3.79313 11.9998H1.00001V9.20672L6.50001 3.70672L9.29313 6.49985L3.79313 11.9998ZM10 5.79297L7.20751 2.99985L8.70751 1.49985L11.5 4.29297L10 5.79297Z"
        fill={fill}
      />
    </svg>
  );
};
